<template>
  <div class="flex flex-col items-center max-w-lg mx-auto mb-3 mt-5 md:my-10 border rounded border-sc-gray-light shadow-sc-secondary">
    <div class="w-full px-8 md:px-16 mt-8 bg-white">
      <h3
        class="text-xl text-primary font-semibold mb-2"
      >
        {{ onboardingStep.name }}
      </h3>
      <form
        @submit.prevent
      >
        <p
          v-if="!!onboardingStep.description"
          class="text-secondary mb-4"
        >
          {{ onboardingStep.description }}
        </p>
        <input
          v-if="onboardingStep.kind === 'text'"
          v-model="value"
          class="w-full px-3 py-2 leading-tight border rounded appearance-none shadow-sc-secondary text-primary border-sc-gray-light focus:outline-none focus:shadow-sc-card focus:border-sc-blue"
        >
        <b-field
          v-else-if="onboardingStep.kind === 'radio'"
        >
          <b-select
            v-model="value"
            expanded
          >
            <option
              v-for="option in onboardingStep.onboardingStepOptions"
              :key="option.id"
              :value="option.id"
            >
              {{ option.label }}
            </option>
          </b-select>
        </b-field>

        <b-field
          v-else-if="onboardingStep.kind === 'checkbox'"
        >
          <b-checkbox
            v-for="option in onboardingStep.onboardingStepOptions"
            :key="option.id"
            :value="option.id"
            v-model="selectedOptions"
            :native-value="option.id"
            class="mb-2"
          >
            {{ option.label }}
          </b-checkbox>
        </b-field>
        <div class="text-red-700 registration-form__alert">
          <p v-if="errors.length">
            <ul>
              <li
                v-for="error in errors"
                :key="error"
              >
                {{ error }}
              </li>
            </ul>
          </p>
        </div>
        <div class="my-4 w-full">
          <navigation-buttons
            :is-form-valid="!!value || selectedOptions.length > 0"
            @next="submitOnboardingAnswer"
            @back="$emit('back')"
            :show-back="showBack"
          />
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import onboardingStepAnswersApi from '../../api/onboarding-step-answers';
import NavigationButtons from './navigation-buttons.vue';

export default {
  components: { NavigationButtons },
  data() {
    return {
      errors: [],
      selectedOptions: [],
      value: '',
    };
  },
  props: {
    onboardingStep: {
      type: Object,
      required: true,
    },
    showBack: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    async submitOnboardingAnswer() {
      if (this.onboardingStep.kind === 'radio') {
        this.selectedOptions = [this.value];
      }

      const body = { value: this.value, onboardingStepOptionsIds: this.selectedOptions };

      try {
        await onboardingStepAnswersApi.createOnboardingStepAnswer(this.onboardingStep.id, body);
        this.$emit('next');
      } catch (error) {
        this.errors.push(error.message);
      }
    },
  },
};
</script>
<style lang="scss">
.field {
  @apply flex flex-col gap-1;
}
</style>
